import api from './api';

/**
 * Convite / boas-vindas Guardian.
 * Docs: POST invite-welcome.
 */
export const guardianInviteService = {
  /**
   * Dispara e-mail de boas-vindas / convite.
   * outcomes: existing_user | created_user | created_user_request
   */
  sendInviteWelcome: async (email) => {
    const response = await api.post('/guardian/invite-welcome/', {
      email: (email || '').trim().toLowerCase(),
    });
    return response.data;
  },
};

export const INVITE_OUTCOME_LABELS = {
  existing_user: 'Usuário existente',
  created_user: 'Usuário criado',
  created_user_request: 'Solicitação de cadastro',
};

export default guardianInviteService;